// extracted by mini-css-extract-plugin
export default {"root":"root--NJVdy","paper":"paper--_jDwD","btn":"btn--hJq5T","btnWrap":"btnWrap--vx2M_","title":"title--Zsu8z","content":"content--LMefZ","markdownText":"markdownText--b_DPU"};